import { css } from 'styled-components'

import { Colours } from '@lib/theme'

export const CSSBasePrimary = css`
  border-color: ${Colours.Brand.BlueMid};
  background-color: ${Colours.Brand.BlueMid};
  color: white;

  :hover {
    background-color: ${Colours.Brand.BlueMid};
    color: white;
    filter: brightness(1.1);
  }
  :active {
    background-color: ${Colours.Brand.BlueMid};
    color: white;
    filter: brightness(1.05);
  }
`
